import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { SeatsBySection } from '@core/models';
import { DvmService, TutorialService } from '@core/services';
import { SeatManagementService } from '@features/digital-venue/services/seat-management.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-section-item',
  templateUrl: './cart-section-item.component.html',
  styleUrl: './cart-section-item.component.scss',
})
export class CartSectionItemComponent implements OnDestroy {
  // SERVICES
  private tutorialService = inject(TutorialService);
  private dvmService = inject(DvmService);
  private seatManagementService = inject(SeatManagementService);
  // INPUTS & OUTPUTS
  @Input()
  public data: SeatsBySection;

  @Input()
  public showSeats: boolean = false;

  @Input()
  public isTicketFeeEnabled: boolean = false;

  @Output()
  public toggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  // GETTERS
  get isGASection() {
    return this.data.id === 'S_BLCHADA' || this.data.id === 'S_Bleacher';
  }

  public get sectionName(): string {
    return this.data?.original_id?.includes('_')
      ? this.data.original_id?.split('_')[1].split('-')[0]
      : this.data.original_id;
  }

  public toggleSeats(): void {
    this.toggle.emit(this.showSeats);
  }

  // PUBLIC COMPONENT METHODS
  public removeSection(): void {
    const sectionData: SeatsBySection = this.data as SeatsBySection;
    const nodeIds: { id: string; originalId: string }[] = Object.values(
      sectionData.seats
    ).map(seat => ({ id: seat.id, originalId: seat.original_id }));

    this.seatManagementService.unselectSelectedSeats(nodeIds);
  }

  //DVM METHODS
  public goToSection(): void {
    if (!this.dvmService.viewerService.isLoaded() || !this.data) {
      return;
    }

    const sectionId: string = this.data.id;
    const actualSection: string = this.dvmService.viewerService.getMapId()!;

    if (sectionId != actualSection) {
      const subscription = this.dvmService.openSeatMap(sectionId).subscribe();
      this.subscriptions.push(subscription);
    }
  }
}
